module.exports = __webpack_public_path__ + "img/Fb.1e5e9d0a.svg";